import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appFocusAndSelect]',
  standalone: true,
})
export class FocusAndSelectDirective implements OnInit {
  @Input()
  appFocusAndSelect: boolean;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
    if (input['focus'] && input['select'] && this.appFocusAndSelect) {
      input.focus();
      input.select();
    }
  }
}
